export default __webpack_public_path__ + "assets/icon-book-default.png";